'use strict';

const location = () => (typeof window !== 'undefined' && window.location);

export default {
  getHost() {
    return location() && window.location.host;
  },

  isFedopsDev() {
    const q = (location() || {}).search || '';
    return q.indexOf(`fedops=dev`) > -1;
  }
};



// WEBPACK FOOTER //
// ./app-data/location.js